import React, { useState } from "react";
import { SettingsType } from "../../../Write";
import { Add, Close, ExpandMore, Remove } from "@material-ui/icons";
import ReactGA from "react-ga";

type Props = {
    values: SettingsType;
    setValues: (arg: SettingsType) => void;
};

const Tab1: React.FC<Props> = (props) => {
    const [character, setCharacter] = useState<string>("");
    const [tag, setTag] = useState<string>("");

    function handleDrop(e: string) {
        document.getElementById(e)?.classList.toggle("show");
    }

    function uploadImage() {
        ReactGA.event({
            category: "Write Story",
            action: "Upload image",
        });
        let input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.oninput = (event: any) => {
            var reader = new FileReader();
            //Read the contents of Image File.
            const cover_image = event.target.files[0];
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = function (e: any) {
                let newValues = Object.assign({}, props.values);
                newValues.cover = e.target.result;
                newValues.cover_image = cover_image;
                props.setValues(newValues);
            };
        };
        input.click();
    }

    return (
        <main>
            <div style={{ marginBottom: 70 }}>
                <p
                    className="input_title required"
                    style={{ marginBottom: "10px" }}
                >
                    Story Title
                </p>
                <input
                    type="text"
                    placeholder="Title comes here..."
                    value={props.values.title}
                    onChange={(event: any) => {
                        let newValues = Object.assign({}, props.values);
                        newValues.title = event.target.value;
                        props.setValues(newValues);
                    }}
                    style={{ marginBottom: "20px" }}
                />
                <p
                    className="input_title required"
                    style={{ marginBottom: "10px" }}
                >
                    Description
                </p>
                <textarea
                    placeholder="Description comes here..."
                    style={{ marginBottom: "20px" }}
                    value={props.values.description}
                    onChange={(event: any) => {
                        let newValues = Object.assign({}, props.values);
                        newValues.description = event.target.value;
                        props.setValues(newValues);
                    }}
                />
                <p
                    className="input_title required"
                    style={{ marginBottom: "10px" }}
                >
                    Main Characters
                </p>
                {props.values.characters.map((value, index) => (
                    <div
                        className="flex"
                        style={{
                            marginBottom: "20px",
                            display: "flex",
                        }}
                    >
                        <input
                            type="text"
                            value={value}
                            onChange={(event: any) => {
                                let newValues = Object.assign({}, props.values);
                                newValues.characters[index] =
                                    event.target.value;
                                props.setValues(newValues);
                            }}
                            placeholder="Title comes here..."
                        />
                        <button
                            className="icon_button"
                            style={{
                                marginLeft: "10px",
                                borderRadius: "7px",
                                height: "44px",
                                minWidth: "44px",
                            }}
                            onClick={() => {
                                let newValues = Object.assign({}, props.values);
                                let characters = [...props.values.characters];
                                characters.splice(index, 1);
                                newValues.characters = [...characters];
                                props.setValues(newValues);
                            }}
                        >
                            <Remove />
                        </button>
                    </div>
                ))}
                <div
                    className="flex"
                    style={{ marginBottom: "20px", display: "flex" }}
                >
                    <input
                        type="text"
                        value={character}
                        onChange={(event: any) => {
                            setCharacter(event.target.value);
                        }}
                        placeholder="Title comes here..."
                    />
                    <button
                        className="icon_button"
                        style={{
                            marginLeft: "10px",
                            borderRadius: "7px",
                            height: "44px",
                            minWidth: "44px",
                        }}
                        onClick={() => {
                            if (character.trim() != "") {
                                let newValues = Object.assign({}, props.values);
                                let characters = [...props.values.characters];
                                characters.push(character.trim());
                                newValues.characters = [...characters];
                                props.setValues(newValues);
                            }
                            setCharacter("");
                        }}
                    >
                        <Add />
                    </button>
                </div>
                <div className="horizontal_divider"></div>
                <p className="input_title" style={{ marginBottom: "10px" }}>
                    Tags
                </p>
                <div
                    className="flex"
                    style={{ marginBottom: "10px", display: "flex" }}
                >
                    <input
                        type="text"
                        value={tag}
                        onChange={(event: any) => {
                            setTag(event.target.value);
                        }}
                        placeholder="Add a new tag..."
                    />
                    <button
                        className="icon_button"
                        style={{
                            marginLeft: "10px",
                            borderRadius: "7px",
                            height: "44px",
                            minWidth: "44px",
                        }}
                        onClick={() => {
                            if (tag.trim() != "") {
                                let newValues = Object.assign({}, props.values);
                                let tags = [...props.values.tags];
                                tags.push(tag.trim());
                                newValues.tags = [...tags];
                                props.setValues(newValues);
                            }
                            setTag("");
                        }}
                    >
                        <Add />
                    </button>
                </div>
                <div className="tags">
                    {props.values.tags.map((value, index) => (
                        <div className="tag">
                            <span>{value}</span>
                            <Close
                                onClick={() => {
                                    let newValues = Object.assign(
                                        {},
                                        props.values
                                    );
                                    let tags = [...props.values.tags];
                                    tags.splice(index, 1);
                                    newValues.tags = [...tags];
                                    props.setValues(newValues);
                                }}
                            />
                        </div>
                    ))}
                </div>
                <div className="horizontal_divider"></div>
                <div className="grid_input">
                    <p className="input_title required">genre</p>
                    <div className="dropdown">
                        <button
                            onClick={() => handleDrop("genre")}
                            className="dropbtn input"
                        >
                            <span style={{ pointerEvents: "none" }}>
                                {props.values.genre !== null &&
                                props.values.genre !== ""
                                    ? props.values.genre
                                    : "Select a genre"}
                            </span>{" "}
                            <ExpandMore style={{ pointerEvents: "none" }} />
                        </button>
                        <div className="dropdown-wrapper pt_0" id="genre">
                            <div className="dropdown-content">
                                <ul>
                                    {[
                                        "Comedy",
                                        "Fantasy",
                                        "Crime",
                                        "Drama",
                                        "Music",
                                        "Adventure",
                                        "History",
                                        "Thriller",
                                        "Animation",
                                        "Family",
                                        "Mystery",
                                        "Biography",
                                        "Action",
                                        "Film-Noir",
                                        "Romance",
                                        "Sci-Fi",
                                        "War",
                                        "Western",
                                        "Horror",
                                        "Musical",
                                        "Sport",
                                    ].map((val) => (
                                        <li
                                            onClick={() => {
                                                let newValues = Object.assign(
                                                    {},
                                                    props.values
                                                );
                                                newValues.genre = val;
                                                props.setValues(newValues);
                                                handleDrop("genre");
                                            }}
                                        >
                                            {val}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="horizontal_divider"></div>
                <div className="grid_input">
                    <p className="input_title required">target audience</p>
                    <div className="dropdown">
                        <button
                            onClick={() => handleDrop("audience")}
                            className="dropbtn input"
                            name="audience"
                        >
                            <span style={{ pointerEvents: "none" }}>
                                {props.values.audience !== null &&
                                props.values.audience !== ""
                                    ? props.values.audience
                                    : "Select a target audience"}
                            </span>{" "}
                            <ExpandMore style={{ pointerEvents: "none" }} />
                        </button>
                        <div className="dropdown-wrapper pt_0" id="audience">
                            <div className="dropdown-content">
                                <ul>
                                    {["Adult", "Kids"].map((val) => (
                                        <li
                                            onClick={() => {
                                                let newValues = Object.assign(
                                                    {},
                                                    props.values
                                                );
                                                newValues.audience = val;
                                                props.setValues(newValues);
                                                handleDrop("audience");
                                            }}
                                        >
                                            {val}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="horizontal_divider"></div>
                <div className="grid_input">
                    <p className="input_title required">language</p>
                    <div className="dropdown">
                        <button
                            onClick={() => handleDrop("language")}
                            className="dropbtn input"
                            name="language"
                        >
                            <span style={{ pointerEvents: "none" }}>
                                {props.values.language !== null &&
                                props.values.language !== ""
                                    ? props.values.language
                                    : "Select a language"}
                            </span>{" "}
                            <ExpandMore style={{ pointerEvents: "none" }} />
                        </button>
                        <div className="dropdown-wrapper pt_0" id="language">
                            <div className="dropdown-content">
                                <ul>
                                    {[
                                        "English",
                                        "French",
                                        "Spanish",
                                        "Arabic",
                                        "Mandarin",
                                        "Russian",
                                        "Portuguese",
                                        "German",
                                        "Japanese",
                                        "Hindi",
                                        "Malay",
                                        "Persian",
                                        "Swahili",
                                        "Tamil",
                                        "Italian",
                                        "Dutch",
                                        "Bengali",
                                        "Turkish",
                                        "Vietnamese",
                                        "Polish",
                                        "Javanese",
                                        "Punjabi",
                                        "Thai",
                                        "Korean",
                                    ].map((val) => (
                                        <li
                                            onClick={() => {
                                                let newValues = Object.assign(
                                                    {},
                                                    props.values
                                                );
                                                newValues.language = val;
                                                props.setValues(newValues);
                                                handleDrop("language");
                                            }}
                                        >
                                            {val}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="horizontal_divider"></div>
                <div className="grid_input">
                    <p className="input_title">Copyrights</p>
                    <div className="dropdown">
                        <button
                            onClick={() => handleDrop("copyrights")}
                            className="dropbtn input"
                            name="copyrights"
                        >
                            <span style={{ pointerEvents: "none" }}>
                                {props.values.copyrights !== null &&
                                props.values.copyrights !== ""
                                    ? props.values.copyrights
                                    : "Select a copyright"}
                            </span>{" "}
                            <ExpandMore style={{ pointerEvents: "none" }} />
                        </button>
                        <div className="dropdown-wrapper pt_0" id="copyrights">
                            <div className="dropdown-content">
                                <ul>
                                    {["All Rights Reserved"].map((val) => (
                                        <li
                                            onClick={() => {
                                                let newValues = Object.assign(
                                                    {},
                                                    props.values
                                                );
                                                newValues.copyrights = val;
                                                props.setValues(newValues);
                                                handleDrop("copyrights");
                                            }}
                                        >
                                            {val}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <p style={{ marginTop: "10px", fontSize: "0.75rem" }}>
                    <b>
                        Your work is not to be used or adapted in any way
                        without your permission.
                    </b>
                </p>
                <div className="horizontal_divider"></div>
                <div className="switch_grid_input">
                    <p>Is your content only for mature audience?</p>
                    <div>
                        <p className="input_title">
                            {props.values.mature ? "Mature" : "All"}
                        </p>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="mature"
                                id="mature"
                                checked={props.values.mature}
                                onChange={(event: any) => {
                                    let newValues = Object.assign(
                                        {},
                                        props.values
                                    );
                                    newValues.mature = event.target.checked;
                                    props.setValues(newValues);
                                }}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
                <p style={{ marginTop: "10px", fontSize: "0.72rem" }}>
                    Your story contains graphic depictions of violence,
                    sexuality, strong language, and/or other mature themes. For
                    more info, please read Pencil’s Content Guidelines.
                </p>
                <div className="horizontal_divider"></div>
                <div className="switch_grid_input">
                    <p>Story viability</p>
                    <div>
                        <p className="input_title">
                            {props.values.viability ? "Private" : "Public"}
                        </p>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="viability"
                                id="viability"
                                checked={props.values.viability}
                                onChange={(event: any) => {
                                    let newValues = Object.assign(
                                        {},
                                        props.values
                                    );
                                    newValues.viability = event.target.checked;
                                    props.setValues(newValues);
                                }}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div>
                <div className="image">
                    {props.values.cover !== null &&
                    props.values.cover !== "" ? (
                        <img src={props.values.cover} />
                    ) : null}
                </div>
                <button className="primary_btn" onClick={uploadImage}>
                    Upload cover image
                </button>
                <button
                    className="secondary_btn"
                    onClick={() => {
                        ReactGA.event({
                            category: "Write Story",
                            action: "Remove image",
                        });
                        let newValues = Object.assign({}, props.values);
                        newValues.cover = "";
                        newValues.cover_image = undefined;
                        props.setValues(newValues);
                    }}
                >
                    Remove cover image
                </button>
            </div>
        </main>
    );
};

export default Tab1;
